import React from "react";
import { authRoles } from "modules/utils/RouteAuth";

export const TestingConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  isPrivate: true,
  auth: authRoles.admin,
  routes: [
    {
      path: "/testing",
      component: React.lazy(() => import("./index"))
    }
  ]
};
